<div class="table-wrapper">
  <div class="table-container">
    <table class="crud-table">
      <thead>
        <tr>
          <th>{{ "CRUD_SETTINGS.DEVICE_NAME" | translate }}</th>
          <th>{{ "CRUD_SETTINGS.DEVICE_TYPE" | translate }}</th>
          <th>{{ "COMMON.ASSET_TYPE" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let section of sectionDefinitions; let i = index">
          <td>{{ section.name }}</td>
          <td>
            <app-show-more
              [items]="
                section.attributeDefinitions.length > 0
                  ? section.attributeDefinitions[0].optionDefinitions
                  : []
              "
              [label]="'value'"
              [isOpen]="openDropdownIndex === i"
              (toggle)="onDropdownToggle(i)"
            ></app-show-more>
          </td>
          <td>
            {{ entityTypeLabels[section.assetType] || section.assetType }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pagination">
      <app-asset-list-pagination
        [pageFromList]="currentPage"
        (pageChanged)="onPageChange($event)"
        [totalItems]="count"
      >
      </app-asset-list-pagination>
    </div>
  </div>
</div>

<ng-template #filterTemplate>
  <div class="filters-wrapper">
    <div class="filter-select-box">
      <label for="filter-select">Filter by:</label>
      <select [(ngModel)]="filter.filterBy">
        <option *ngFor="let option of filterOptions" [ngValue]="option.key">
          {{ option.label }}
        </option>
      </select>
    </div>

    <div class="search-bar">
      <img
        src="assets/icons/search.svg"
        alt="Search icon"
        class="search-icon"
      />
      <input
        [(ngModel)]="filter.search"
        type="text"
        class="search-input"
        (keydown.enter)="onSearchEnter()"
        [placeholder]="'COMMON.SEARCH' | translate"
      />
    </div>
    <div class="dropdown">
      <button
        (click)="toggleSortDropdown = !toggleSortDropdown"
        class="dropdown-button"
      >
        {{ sortByName }}
        <img src="assets/icons/ng_v3/dropdown-icon.svg" alt="dropdown icon" />
      </button>
      <div *ngIf="toggleSortDropdown" class="dropdown-options">
        <div
          class="dropdown-option"
          (click)="selectSortByOption(SortType.NEWEST)"
        >
          <span>Newest</span>
          <svg *ngIf="sortBy === SortType.NEWEST" ...>✓</svg>
        </div>
        <div
          class="dropdown-option"
          (click)="selectSortByOption(SortType.OLDEST)"
        >
          <span>Oldest</span>
          <svg *ngIf="sortBy === SortType.OLDEST" ...>✓</svg>
        </div>
        <div
          class="dropdown-option"
          (click)="selectSortByOption(SortType.DEVICE_NAME_ASC)"
        >
          <span>Equipment Name ↑</span>
          <svg *ngIf="sortBy === SortType.DEVICE_NAME_ASC" ...>✓</svg>
        </div>
        <div
          class="dropdown-option"
          (click)="selectSortByOption(SortType.DEVICE_NAME_DESC)"
        >
          <span>Equipment Name ↓</span>
          <svg *ngIf="sortBy === SortType.DEVICE_NAME_DESC" ...>✓</svg>
        </div>
      </div>
    </div>
  </div>

  <div class="filter-button-group">
    <span class="drag-handle"></span>
    <button (click)="openReorderModal()">
      Reorder
      <svg
        width="25"
        height="16"
        viewBox="0 0 10 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.99347 15.2311C1.655 15.2311 1.36526 15.1106 1.12424 14.8695C0.883211 14.6285 0.762695 14.3388 0.762695 14.0003C0.762695 13.6618 0.883211 13.3721 1.12424 13.1311C1.36526 12.8901 1.655 12.7695 1.99347 12.7695C2.33194 12.7695 2.62168 12.8901 2.86269 13.1311C3.10373 13.3721 3.22424 13.6618 3.22424 14.0003C3.22424 14.3388 3.10373 14.6285 2.86269 14.8695C2.62168 15.1106 2.33194 15.2311 1.99347 15.2311ZM7.99347 15.2311C7.655 15.2311 7.36526 15.1106 7.12424 14.8695C6.88321 14.6285 6.76269 14.3388 6.76269 14.0003C6.76269 13.6618 6.88321 13.3721 7.12424 13.1311C7.36526 12.8901 7.655 12.7695 7.99347 12.7695C8.33193 12.7695 8.62168 12.8901 8.86269 13.1311C9.10373 13.3721 9.22424 13.6618 9.22424 14.0003C9.22424 14.3388 9.10373 14.6285 8.86269 14.8695C8.62168 15.1106 8.33193 15.2311 7.99347 15.2311ZM1.99347 9.23108C1.655 9.23108 1.36526 9.11057 1.12424 8.86953C0.883211 8.62852 0.762695 8.33878 0.762695 8.00031C0.762695 7.66184 0.883211 7.3721 1.12424 7.13108C1.36526 6.89005 1.655 6.76953 1.99347 6.76953C2.33194 6.76953 2.62168 6.89005 2.86269 7.13108C3.10373 7.3721 3.22424 7.66184 3.22424 8.00031C3.22424 8.33878 3.10373 8.62852 2.86269 8.86953C2.62168 9.11057 2.33194 9.23108 1.99347 9.23108ZM7.99347 9.23108C7.655 9.23108 7.36526 9.11057 7.12424 8.86953C6.88321 8.62852 6.76269 8.33878 6.76269 8.00031C6.76269 7.66184 6.88321 7.3721 7.12424 7.13108C7.36526 6.89005 7.655 6.76953 7.99347 6.76953C8.33193 6.76953 8.62168 6.89005 8.86269 7.13108C9.10373 7.3721 9.22424 7.66184 9.22424 8.00031C9.22424 8.33878 9.10373 8.62852 8.86269 8.86953C8.62168 9.11057 8.33193 9.23108 7.99347 9.23108ZM1.99347 3.23108C1.655 3.23108 1.36526 3.11057 1.12424 2.86953C0.883211 2.62852 0.762695 2.33877 0.762695 2.00031C0.762695 1.66184 0.883211 1.3721 1.12424 1.13108C1.36526 0.890049 1.655 0.769531 1.99347 0.769531C2.33194 0.769531 2.62168 0.890049 2.86269 1.13108C3.10373 1.3721 3.22424 1.66184 3.22424 2.00031C3.22424 2.33877 3.10373 2.62852 2.86269 2.86953C2.62168 3.11057 2.33194 3.23108 1.99347 3.23108ZM7.99347 3.23108C7.655 3.23108 7.36526 3.11057 7.12424 2.86953C6.88321 2.62852 6.76269 2.33877 6.76269 2.00031C6.76269 1.66184 6.88321 1.3721 7.12424 1.13108C7.36526 0.890049 7.655 0.769531 7.99347 0.769531C8.33193 0.769531 8.62168 0.890049 8.86269 1.13108C9.10373 1.3721 9.22424 1.66184 9.22424 2.00031C9.22424 2.33877 9.10373 2.62852 8.86269 2.86953C8.62168 3.11057 8.33193 3.23108 7.99347 3.23108Z"
          fill="#151918"
          fill-opacity="0.8"
        />
      </svg>
    </button>
    <button (click) ="downloadSectionDefinition()">Download</button>
  </div>
</ng-template>

<ng-container *ngIf="showReorderModal">
      <app-reorder-section-definition
          data-bs-toggle="modal"
          data-bs-target="#edtitAddModal"
        (closeModal)="onCloseReorderModal()"
      ></app-reorder-section-definition>
</ng-container>


<ng-container *ngIf="showAddNewModal">
      <app-add-new-section-definition
          data-bs-toggle="modal"
          data-bs-target="#edtitAddModal"
        (closeModal)="onCloseAddNewModal()"
        (saved)="onSectionDefinitionSaved()"
      ></app-add-new-section-definition>
</ng-container>